<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <solicitud-registrar-form @success="success"></solicitud-registrar-form>
  </div>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <div>
            <solicitud-registrar-form @success="success"></solicitud-registrar-form>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {
      'solicitud-registrar-form': require('./SolicitudRegistrarForm').default
    },

    methods: {
      success(data) {
        this.$router.go(-1)
      }
    }
  }
</script>
